import React, { useEffect, useState, } from 'react';
import { Link, useHistory, useParams, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';

import { isNull, isUndefined, } from 'lodash';
import Swal from 'sweetalert2';

import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, responseGet, globalSettings, styles, validatePhoneNumber, sendMessageCloseCurrentWindowAsync, buttonProcessGet, awaitDelay, processEvaluateGet, validateDecimals,
    languageObjGet, isUndNullEmp, LoadingSection, numberSet,
} from '../../helpers/settings';

import { apartmentPeopleModelGet } from '../../models/apartments/apartmentPeople';
import ApartmentUserAdd from './ApartmentUserAdd';
import ApartmentPeopleAddEditDetails from './ApartmentPeopleAddEditDetails';
import Menu from '../main/Menu';
import BuildingHeader from '../buildings/BuildingHeader';
import { validationPeopleTypeGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { peopleTypeModelGet } from '../../models/peopleTypes/peopleType';

const currentMethod = 'ApartmentEdit';

//const { app, collections: dbColle, icons, labels, messages, react, } = globalSettings;
const { app, collections: dbColle, icons, labels, messages } = globalSettings;
const { properties: dbProps, } = dbColle;
//const { operators: dbOpera, } = react?.firebase;
const { backend, } = app;

export default function ApartmentEdit({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    const history = useHistory();
    //const userRole = checkIfUserIsMaster({email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [processType, setProcessType] = useState();
    const [showLoading, setShowLoading] = useState({ building: true, apartment: true, apartmentUsers: true, apartmentPeoples: true, });
    const percentageValues = {
        empty: 0.00,
        full: 0.00,
    };
    let swalProperties = {};
    //const [showData, setShowData] = useState(false);
    //#endregion others

    //#region apartment
    //let apartmentTwo = {};
    const [apartment, setApartment] = useState(apartmentModelGet({}));
    const [floorError, setFloorError] = useState('');
    const [identifierError, setIdentifierError] = useState('');
    const [parkingPlaceError, setParkingPlaceError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [aliquotPercentageError, setAliquotPercentageError] = useState('');
    //#endregion apartment

    //#region building
    let buildingTwo = buildingModelGet({});
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildingFloors, setBuildingFloors] = useState([]);
    const [buildingAliquotPercentage, setBuildingAliquotPercentage] = useState(false);
    //#endregion building

    //#region artment users
    let apartmentUsers = [apartmentUserModelGet({})];
    const dtApartmentUsersId = 'dtApartmentUsers';
    const [showModalApartmentUsers, setShowModalApartmentUsers] = useState(false);
    const [apartmentUsersTwo, setApartmentUsersTwo] = useState([apartmentUserModelGet({})]);
    //#endregion apartment users

    //#region apartment peoples
    let apartmentPeoples = [apartmentPeopleModelGet({})];
    const dtApartmentPeoplesId = 'dtApartmentPeoples';
    const [showModalApartmentPeoples, setShowModalApartmentPeoples] = useState(false);
    const [peopleTypes, setPeopleTypes] = useState([peopleTypeModelGet({})]);
    const [dtApartmentPeoplesRowIndexTwo, setDtApartmentPeoplesRowIndexTwo] = useState(0);
    const [apartmentPeople, setApartmentPeople] = useState(apartmentPeopleModelGet({}));
    //#endregion apartment peoples

    //#region others
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnBack',
            },
        },
        checkBox: {
            // topLevel: {
            //     id: 'chkTopLevel',
            //     className: 'icheck-primary',
            // },
            // lowLevel: {
            //     id: 'chkLowLevel',
            //     className: 'icheck-primary',
            // }
        },
        dataTables: {
            apartmentUsers: {
                buttons: {
                    add: {
                        id: 'btnApartmentuserAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoApartmentuserAdd',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtApartmentUsersId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtApartmentUsersId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spApartmentuserAdd',
                        className: '',
                    },
                },
            },
            apartmentPeoples: {
                buttons: {
                    add: {
                        id: 'btnApartmentPeoplesAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoApartmentPeoplesAdd',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtApartmentPeoplesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtApartmentPeoplesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spApartmentPeoplesAdd',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                className: icons?.save,
            },
            back: {
                id: 'iconBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            identifier: {
                id: 'inputIdentifier',
                className: 'form-control',
            },
            aliquot: {
                id: 'inputAliquot',
                className: 'form-control text-right',
            },
            parkingStalls: {
                id: 'inputParkingStalls',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
                className: 'form-control',
            },
        },
        selects: {
            floor: {
                id: 'selFloor',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others
    //#endregion variables

    //#region apartment (methods)
    const buildingFloorsGet = ({
        subMethod = '', }) => {
        const currentMethod = 'buildingFloorsGet';
        let response = responseGet();
        try {
            let buildingFloorsLocal = [];
            if (!isUndNullEmp({ data: buildingTwo, subMethod: currentMethod, })?.result) {
                if (buildingTwo?.lowLevel) {
                    buildingFloorsLocal?.push({ label: 'PB', value: 0, });
                }

                if (buildingTwo?.floors > 0) {
                    for (let index = 0; index < buildingTwo?.floors; index++) {
                        buildingFloorsLocal?.push({ label: `${labels?.floor?.[languageObj?.id]} ${index + 1}`, value: index + 1, });
                    }
                }

                if (buildingTwo?.topLevel && buildingTwo?.floors > 0) {
                    buildingFloorsLocal?.push({ label: 'PH', value: (buildingTwo?.floors + 1), });
                }
            }
            setBuildingFloors(buildingFloorsLocal);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setFloorError('');
            setIdentifierError('');
            setParkingPlaceError('');
            setPhoneNumberError('');
            setAliquotPercentageError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (apartment.floor < 0) {
                setFloorError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: apartment?.identifier, subMethod: currentMethod, })?.result) {
                setIdentifierError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: apartment?.phoneNumber, subMethod: currentMethod, })?.result && !validatePhoneNumber({ phoneNumber: apartment.phoneNumber, })) {
                setPhoneNumberError(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (buildingAliquotPercentage) {
                if (isUndNullEmp({ data: apartment?.aliquotPercentage, subMethod: currentMethod, })?.result) {
                    setAliquotPercentageError(messages?.theValueMustBeGreaterThanOrEqualToZeroAndLessThanOneHundred?.[languageObj?.id]);
                    response.isWarning = true;
                } else if (apartment?.aliquotPercentage < percentageValues?.empty || percentageValues?.full) {
                    setAliquotPercentageError(messages?.theValueMustBeGreaterThanOrEqualToZeroAndLessThanOneHundred?.[languageObj?.id]);
                    response.isWarning = true;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'apartmentDataSetAsync';
        let response = responseGet();
        try {
            apartment.aliquotPercentage = !isUndNullEmp({ data: apartment?.aliquotPercentage, subMethod: currentMethod, })?.result ?
                parseFloat(apartment?.aliquotPercentage) : percentageValues?.empty;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentEditPostAsync';
        let response = responseGet();
        try {
            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await apartmentDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            //setShowLoading({ building: false, apartment: true, apartmentUsers: false, apartmentPeople: false, });
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartments}/${apartment.id}`,
                apartment: apartment,
                languageId: languageObj?.id,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeople: false, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeople: false, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            //setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeople: false, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion apartment (methods)

    //#region aparment users (methods)
    const apartmentUsersGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentUsersGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let apartmentUsersLocal = [apartmentUserModelGet({})];
            //#endregion variables

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            //#region old code
            // dataObj = {
            //     conditionals: [
            //         { field: dbProps?.contracts, operator: dbOpera?.arrayContains, value: { id: building?.contractId, }, },
            //     ],
            //     ordersBy: [
            //         { field: dbProps?.email, value: 'asc' }
            //     ],
            //     method: backend?.methods?.apartmentUsers?.getAsync,
            //     languageId: languageObj?.id,
            //     url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`,
            // };
            //#endregion old code

            dataObj = {
                buildingId: building?.id,
                limit: 0,
                ordersBy: [],
                conditionals: [],
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentUsersLocal = response.result;
            if (!isUndefined(apartmentUsersLocal) && !isNull(apartmentUsersLocal) && apartmentUsersLocal.length > 0) {
                setApartmentUsersTwo(apartmentUsersLocal);
            } else {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.notRegisteredUsersYet?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setShowModalApartmentUsers(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTableAparmentUsersSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableAparmentUsersSet';
        let response = responseGet();
        try {
            $(`#${dtApartmentUsersId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.firstName?.[languageObj?.id], width: '30%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '30%', },
                    { title: labels?.email?.[languageObj?.id], width: '35%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc', 1, 'asc']],
                ordering: true,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentUsersId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentUsersLoadAsync = async ({ data = [apartmentUserModelGet({})], subMethod = '', }) => {
        const currentMethod = 'apartmentUsersLoadAsync';
        let response = responseGet()
        try {
            if (!isUndNullEmp({ data: data, subMethod: currentMethod, })?.result && data?.length > 0) {
                data?.forEach((detail,) => {
                    apartmentUsers.push([
                        detail?.user?.firstName,
                        detail?.user?.lastName,
                        detail?.user?.email,
                        buttonProcessGet({
                            id: detail.id,
                            description: `${detail?.user?.firstName}, ${detail?.user?.lastName}`,
                            showDetails: false,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: false,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.delete.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        }).result
                    ]);
                });
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentUserDeleteGetAsync = async ({ id_ = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'apartmentUserDeleteGetAsync';
        let response = responseGet();
        try {
            // //#region show message
            // const swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: `${labels?.user?.[languageObj?.id]}: <b>${description}</b><br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);
            // //#endregion show message

            // //#region delete data
            // if (isConfirmed) {
            //     sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //         },
            //     };
            //     //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlApartmentUsers}/${id}`, headerObj);
            //     result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/${id_}`, headerObj);
            //     response = result.data;

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }

            //     $(`#${dtApartmentUsersId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
            //     sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            // }
            // //#endregion delete data

            //#region show message
            let msgTextObj = {
                one: `${labels?.user?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region delete data (user)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/${id_}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;
                        }
                        //#endregion delete data (apartmentUser)

                        //#region delete dataTable (apartmentUser)
                        $(`#${dtApartmentUsersId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion delete dataTable (apartmentUser)
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }
    //#endregion aparment users (methods)

    //#region apartments peoples (methods)
    const dataTableAparmentPeoplesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableAparmentPeoplesSet';
        let response = responseGet();
        try {
            $(`#${dtApartmentPeoplesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.firstName?.[languageObj?.id], width: '30%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '30%', },
                    { title: labels?.type?.[languageObj?.id], width: '35%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'], [1, 'asc']],
                ordering: true,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentPeoplesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentPeoplesAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentPeoplesAddGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let peopleTypesLocal = [];
            //#region response is warning
            //#endregion response is warning
            //#endregion variables

            controlsStatusSet({ processType: 4, subMethod: currentMethod, });

            response = await validationPeopleTypeGetAsync({
                buildingId: building?.id || (buildingTwo?.id || ''),
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            peopleTypesLocal = response?.result;

            setPeopleTypes(peopleTypesLocal);
            setProcessType(0);
            setApartmentPeople(apartmentPeopleModelGet({
                buildingId: apartment?.buildingId,
                apartmentId: apartment?.id,
            }));

            setShowModalApartmentPeoples(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentPeoplesEditDetailsGetAsync = async ({ id_ = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'apartmentPeoplesEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let peopleTypesLocal = [];
            let apartmentPeopleLocal = {};
            //#region responseIsWarning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }
            //#endregion responseIsWarning
            //#endregion variables

            //controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: true, });

            //#region apartment get people
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentPeoples}/${id_}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentPeopleLocal = response?.result;
            setApartmentPeople(apartmentPeopleLocal);
            //#endregion apartment get people

            //#region data get (people types)
            response = await validationPeopleTypeGetAsync({
                buildingId: buildingTwo?.id || building?.id,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            peopleTypesLocal = response?.result;
            //#endregion data get (people types)

            setPeopleTypes(peopleTypesLocal);
            //setProcessType(1);
            setProcessType(processType_);
            setDtApartmentPeoplesRowIndexTwo(rowIndex);
            setShowModalApartmentPeoples(true);
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const peopleTypeGet = ({ peopleTypeId = {}, peopleTypes = [], subMethod = '', }) => {
        const currentMethod = 'peopleTypeGet';
        let response = responseGet();
        try {
            const peopleTypeLocal = peopleTypes?.find(({ id }) => id === peopleTypeId);
            if (isUndNullEmp({ data: peopleTypeLocal, subMethod: currentMethod, })?.result) {
                response.msgType = 1;
                response.isWarning = true;
                response.result = labels?.notFound?.[languageObj?.id];
            } else {
                response.result = peopleTypeLocal?.description;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `Error: ${currentMethod}`;
        }
        return response;
    }

    const apartmentPeoplesLoadAsync = async ({ data = [apartmentPeopleModelGet({})], subMethod = '', }) => {
        const currentMethod = 'apartmentPeoplesLoadAsync';
        let response = responseGet()
        try {
            if (!isUndNullEmp({ data: data, subMethod: currentMethod, })?.result && data?.length > 0) {
                data?.forEach((detail,) => {
                    apartmentPeoples.push([
                        detail?.firstName,
                        detail?.lastName,
                        detail?.peopleType?.description,
                        buttonProcessGet({
                            id: detail?.id,
                            description: `${detail?.firstName}, ${detail?.lastName}`,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.detail.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result
                    ])
                });
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentPeopleDeleteGetAsync = async ({ id_ = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'apartmentPeopleDeleteGetAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.apartmentPeople?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region delete data (user)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentPeoples}/${id_}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;
                        }
                        //#endregion delete data (apartmentUser)

                        //#region delete dataTable (apartmentUser)
                        $(`#${dtApartmentPeoplesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion delete dataTable (apartmentUser)
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }
    //#endregion apartments peoples (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, apartment: true, apartmentUsers: true, apartmentPeoples: true, });
            //setShowData(false);

            //#region variables
            apartmentUsers = [];
            apartmentPeoples = [];

            let apartmentLocal = apartmentModelGet({});
            let apartmentUsersLocal = [apartmentUserModelGet({})];
            let apartmentPeoplesLocal = [apartmentPeopleModelGet({})];
            //#endregion variables

            //#region dataTable set and query code
            response = dataTablesSet({
                dtApartmentUsers: true,
                dtApartmentPeoples: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set and query code

            //#region data get
            //#region old code
            // if (userRole === '') {
            //     setShowLoading({building: false, apartment: false, apartmentUsers: false, peopleTypes: false, });
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(1, messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id], false, backend?.urlHome, auth, false);
            //     return;
            // }
            //#endregion old code

            //#region apartment get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                id: id,
                conditionals: [],
                ordersBy: [],
                method: backend?.methods?.apartments.apartmentWithDetails,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingTwo = response?.result?.building;
            apartmentLocal = response?.result?.apartment;
            apartmentUsersLocal = response?.result?.apartmentUsers;
            apartmentPeoplesLocal = response?.result?.apartmentPeoples;

            setBuilding(buildingTwo);
            setBuildingAliquotPercentage(buildingTwo?.settings?.accountsReceivable?.aliquotPercentage || false);

            if (!isUndNullEmp({ data: apartmentLocal, subMethod: currentMethod, })?.result) {
                setApartment(apartmentLocal);

                //#region load apartment users
                response = await apartmentUsersLoadAsync({
                    data: apartmentUsersLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                    //setShowData(false);
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion load apartment users

                //#region load apartment peoples
                response = await apartmentPeoplesLoadAsync({
                    data: apartmentPeoplesLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                    //setShowData(false);
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                //#endregion load apartment peoples
            } else {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.theRecordCannotBeLocated?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion apartment get

            //#region building get
            response = buildingFloorsGet({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building get
            //#endregion data get

            //#region load datatable
            $(`#${dtApartmentUsersId}`)?.DataTable()?.rows?.add(apartmentUsers)?.draw();
            $(`#${dtApartmentPeoplesId}`)?.DataTable()?.rows?.add(apartmentPeoples)?.draw();
            //#endregion load datatable

            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let method = '';
            let idLocal = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region data table (Apartment Users)
            $(`#${dtApartmentUsersId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtApartmentUsersId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    idLocal = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'delete':
                            apartmentUserDeleteGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (Apartment Users)

            //#region data table (iventories)
            $(`#${dtApartmentPeoplesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtApartmentPeoplesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    idLocal = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            apartmentPeoplesEditDetailsGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            apartmentPeoplesEditDetailsGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            apartmentPeopleDeleteGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (iventories)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({ dtApartmentUsers = false, dtApartmentPeoples = false, queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            if (dtApartmentUsers) {
                response = dataTableAparmentUsersSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtApartmentPeoples) {
                response = dataTableAparmentPeoplesSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                response = queryCodeSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setApartment({
                ...apartment,
                [property]:
                    value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const goToBackAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            history?.push(backend?.urlApartments);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.icons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.spinners?.add?.className);

                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.icons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.spinners?.add?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.selects?.floor?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.identifier?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.aliquot?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.parkingStalls?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTables
            $(`#${controls?.dataTables?.apartmentUsers?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentUsers?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentPeoples?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentPeoples?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTables

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='apartments' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.apartment?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={backend?.urlApartments}>{labels?.apartments?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.apartment?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader
                                    buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={null}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/* {!showLoading ?
                                    <div> */}
                                {/* {showData ?
                                            <div> */}
                                {/*apartment*/}
                                <form onSubmit={(e) => apartmentEditPostAsync({ e: e, subMethod: 'btn - apartmentSave', })}>
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.apartment}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={labels?.apartment?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.apartmentsLogo}></img>
                                                - {labels?.apartment?.[languageObj?.id]} ({labels?.edit?.[languageObj?.id]})
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={icons?.minus}></i>
                                                </button>
                                                {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>
                                            <div>
                                                {/*apartment data*/}
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className='input-group mb-3'>
                                                                {/* {!isUndNullEmp({ data: buildingFloors, subMethod: currentMethod, })?.result && !isUndNullEmp({ data: apartment, subMethod: currentMethod, })?.result && buildingFloors?.length > 0 ? */}
                                                                <select id={controls?.selects?.floor?.id}
                                                                    className={controls?.selects?.floor?.className}
                                                                    //defaultValue={apartment?.floor || -1}
                                                                    value={`${apartment?.floor}` || `-1`}
                                                                    onChange={(e) => formDataSetAsync({
                                                                        property: dbProps?.floor,
                                                                        value: parseInt(e?.target?.value),
                                                                        subMethod: 'input - floor',
                                                                    })}
                                                                    onFocus={() => setFloorError('')}
                                                                    placeholder={labels?.floor?.[languageObj?.id]}
                                                                    tooltip='tooltip'
                                                                    title={labels?.floor?.[languageObj?.id]}>
                                                                    <option value={`-1`}>{messages?.selectFloor?.[languageObj?.id]}</option>
                                                                    {buildingFloors?.map((bf) => <option key={bf?.value} value={`${bf?.value}`}>{bf?.label}</option>)}
                                                                </select>
                                                                {/* : */}
                                                                {/* <></> */}
                                                                {/* } */}
                                                                <div className='input-group-append'>
                                                                    <div className='input-group-text'>
                                                                        <span className={icons?.layerGroup} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(floorError)}</div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className='input-group mb-3'>
                                                                <input id={controls?.inputs?.identifier?.id}
                                                                    className={controls?.inputs?.identifier?.className}
                                                                    //autoFocus
                                                                    placeholder={labels?.identifier?.[languageObj?.id]}
                                                                    onChange={(e) => formDataSetAsync({ property: 'identifier', value: e?.target?.value, subMethod: 'input - identifier', })}
                                                                    onFocus={() => setIdentifierError('')}
                                                                    value={apartment?.identifier || ''}
                                                                    tooltip='tooltip'
                                                                    title={labels?.identifier?.[languageObj?.id]} />
                                                                <div className='input-group-append'>
                                                                    <div className='input-group-text'>
                                                                        <span className={icons?.sign} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(identifierError)}</div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        {buildingAliquotPercentage ?
                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.aliquot?.id}
                                                                        className={controls?.inputs?.aliquot?.className}
                                                                        placeholder={`% ${labels?.aliquot?.[languageObj?.id]}`}
                                                                        //onChange={(e) => formDataSetAsync('aliquotPercentage', validateDecimals(e))}
                                                                        onChange={(e) => formDataSetAsync({
                                                                            property: 'aliquotPercentage',
                                                                            value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', }))) ?
                                                                                numberSet({ number: `${percentageValues?.empty}`, type: 'd', languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', })?.result :
                                                                                validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', }),
                                                                        })}
                                                                        onFocus={() => setAliquotPercentageError('')}
                                                                        value={apartment?.aliquotPercentage || '0.00'}
                                                                        tooltip='tooltip'
                                                                        title={`% ${labels?.aliquot?.[languageObj?.id]}`} />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'>
                                                                            <span className={icons?.percentage} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(aliquotPercentageError)}</div>
                                                            </div> :
                                                            <></>
                                                        }
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className='input-group mb-3'>
                                                                <input id={controls?.inputs?.parkingStalls?.id}
                                                                    className={controls?.inputs?.parkingStalls?.className}
                                                                    onChange={(e) => formDataSetAsync({ property: 'parkingPlace', value: parseInt(e?.target?.value), subMethod: 'input - parkinPlace', })}
                                                                    onFocus={() => setParkingPlaceError('')}
                                                                    tooltip='tooltip'
                                                                    title={labels?.parkingStalls?.[languageObj?.id]}
                                                                    placeholder={labels?.parkingStalls?.[languageObj?.id]}
                                                                    type='number'
                                                                    value={apartment?.parkingPlace || ''} />
                                                                <div className='input-group-append'>
                                                                    <div className='input-group-text'>
                                                                        <span className={icons?.car} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(parkingPlaceError)}</div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className='input-group mb-3'>
                                                                <input id={controls?.inputs?.phoneNumber?.id}
                                                                    className={controls?.inputs?.phoneNumber?.className}
                                                                    placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                                    onChange={(e) => formDataSetAsync({ property: 'phoneNumber', value: e?.target?.value, subMethod: 'input - phoneNumber', })}
                                                                    onFocus={() => setPhoneNumberError('')}
                                                                    value={apartment?.phoneNumber || ''}
                                                                    tooltip='tooltip'
                                                                    title={labels?.phoneNumber?.[languageObj?.id]} />
                                                                <div className='input-group-append'>
                                                                    <div className='input-group-text'>
                                                                        <span className={icons?.fax} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(phoneNumberError)}</div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <div className='form-group text-right'>
                                                            <button id={controls?.buttons?.save?.id}
                                                                className={controls?.buttons?.save?.className}
                                                                tooltip='tooltip'
                                                                title={labels?.save?.[languageObj?.id]}
                                                                type='submit'>
                                                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                            </button>
                                                            <button id={controls?.buttons?.back?.id}
                                                                className={controls?.buttons?.back?.className}
                                                                tooltip='tooltip'
                                                                title={labels?.back?.[languageObj?.id]}
                                                                type='reset'
                                                                onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - goToBack', })}>
                                                                <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}
                                </form>

                                {/*apartment users*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.apartmentUsers}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.tenant?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.keyHouse}></img> - {labels?.owner?.[languageObj?.id]} / {labels?.tenant?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        {!isUndNullEmp({ data: apartment, subMethod: currentMethod, })?.result &&
                                            !isUndNullEmp({ data: building, subMethod: currentMethod, })?.result &&
                                            !isUndNullEmp({ data: apartmentUsers, subMethod: currentMethod, })?.result ?
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <button id={controls?.dataTables?.apartmentUsers?.buttons?.add?.id}
                                                        className={controls?.dataTables?.apartmentUsers?.buttons?.add?.className}
                                                        tooltip='tooltip'
                                                        title={labels?.create?.[languageObj?.id]}
                                                        onClick={(e) => apartmentUsersGetAsync({ e: e, subMethod: 'btn - apartmentUserAdd', })}>
                                                        <i id={controls?.dataTables?.apartmentUsers?.icons?.add?.id} className={controls?.dataTables?.apartmentUsers?.icons?.add?.className} /> <span id={controls?.dataTables?.apartmentUsers?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtApartmentUsersId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <></>}

                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                                {/*apartment peoples*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.apartmentPeoples}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.occupants?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.familyLogo}></img> - {labels?.occupants?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <button id={controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}
                                                    className={controls?.dataTables?.apartmentPeoples?.buttons?.add?.className}
                                                    //className='btn btn-outline-success float-right btn-sm'
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    onClick={(e) => apartmentPeoplesAddGetAsync({ e: e, subMethod: 'btn - apartmentPeople', })}>
                                                    <i id={controls?.dataTables?.apartmentPeoples?.icons?.add?.id} className={controls?.dataTables?.apartmentPeoples?.icons?.add?.className} /> <span id={controls?.dataTables?.apartmentPeoples?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtApartmentPeoplesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}
                                {/* </div>
                                            :
                                            <div></div>
                                        } */}
                                {/* </div>
                                    :
                                    <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                        width={40}
                                        height={40}
                                        color={globalSettings?.colors?.infoColorExp}
                                        msgText={messages?.processing?.[languageObj?.id]}
                                        msgOrientation='text-center'
                                        msgTextMuted={true} />
                                } */}


                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModalApartmentUsers ?
                <ApartmentUserAdd $={$}
                    auth={auth}
                    showModal={showModalApartmentUsers}
                    setShowModal={setShowModalApartmentUsers}
                    apartment={apartment}
                    apartmentUsers={apartmentUsersTwo}
                    dtId={dtApartmentUsersId}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalApartmentPeoples ?
                <ApartmentPeopleAddEditDetails $={$}
                    auth={auth}
                    showModal={showModalApartmentPeoples}
                    setShowModal={setShowModalApartmentPeoples}
                    apartmentPeople={apartmentPeople}
                    setApartmentPeople={setApartmentPeople}
                    peopleTypes={peopleTypes}
                    peopleTypeGet={peopleTypeGet}
                    dtId={dtApartmentPeoplesId}
                    dtRowIndex={dtApartmentPeoplesRowIndexTwo}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}